module.exports = __webpack_public_path__ + "static/media/material-master.7d453726.jpeg";